<template>
  <div id="registro" class="zindex10">
    <section id="fondo">
      <div class="container">
        <div class="row pt-5 mb-4">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>
        <div class="row py-3">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>

        <div class="row">
          <div class="col-12 zindex10">
            <div class="row">
              <div class="col-12 z100">
                <div class="row py-5">
                  <div class="col-12 text-center py-4 pt-5 blanco zindex10">
                    <h2 class="blanco fXXG bold">GANADORES</h2>
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center blanco zindex10">&nbsp;</div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 1</div>
                  <div class="col-12 fG bold">23 al 29 de marzo de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO UNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>IwTY22xqQohxiFLbLfXhaYaJXqE3</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>cAVIpvZVTMO7Og2my2PMHZRD6lF2</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>BonepWAMG0RgJ8sXFKxWhRU75DH3</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>7unp7uUl2gWSL0UyfF8WVrqz8ir2</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>DCKgImcQtoWjJdXUfZwtCDRcKle2</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>6fHzSHsaoQXJ2bxAdJMjpzQ9Rul1</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>RgkE67j41FRb779BKBWCiCM9wke2</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>QhVw0qIvekgKhgOVrx9AV8Fd6uC3</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>8qQA0AQmRAcSPt4vG6AxrtQQDDC3</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>AwyiW03fPwUQp7oHqMc62jXlqev2</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>tWoPQ9bEwRRBpzW6n059JFNGbfg1</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>WhCNPrEfBmb1aVHlfBDNEjCjgnr2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>EV3QNKR9t2gPFrhdzpWkjkzNaUW2</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>M9KbQ3kbVHYcscpGniXuRKRRuqC3</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>fYzLXWNnIrWqAfBS5rChXTaOqT42</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>eWuipCrlymhlCEmacNtft4ZylpU2</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>JiQUBHRwaROslXSLONwEGs16jRg1</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>2QhEhDJL65OvRUld7YtWzZLExuD2</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>XRcPvNClHcU24od5ajEjX3WlBe32</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>HyLfPPlqNuS3G35AKNDJBNHy4S33</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center blanco zindex10">&nbsp;</div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 2</div>
                  <div class="col-12 fG bold">
                    30 de marzo al 05 de abril de 2026
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO UNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>lXKT4SZsfRh9KKJUouVUTeTj5UG2</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>jbyj5OTL78axR7gkpovjtT6H96v1</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>GvN5rG4SEWguWa7lPGXXxqOFGvh1</td>
                        </tr>

                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>yQGlVlTU2dctVuP9yAVfBSLfpce2</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>gWVV0vLvjvdFheyqJqAGdcZkxmI2</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>V14EutiAebOy3K05729boDQdYTK2</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ySamnSeJPUXwhG9TULo5QD7OG3g1</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>zgHwQtUqVWYWHRvkAfQ61Epf1Fo1</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>PxaG7JBrqofD33eDWBU3HrwlkPG2</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>MjoAP2HQLoRrmsl5Z2TQbNv32So1</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>S94QaMru2sXj81TLtyt0M3h6Rzf1</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>uH4ARD0zaEYiUQUxNcmG1pL61go2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>dwUVftyoLwdIVo38forsJBJvthu2</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>3iry3w1bbig81wYm9YPLWUztjd83</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>qMQqzTzz69OOLQcSPswhRNsuay43</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>rMKOeWgRAGeovtgtjBP00pjcgV73</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>hVPD4YvVuMYvi0idl5TlfXEqKYj2</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>K5MGBM2FehT7pqwpCNRV8hHxJsV2</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>Ct5t7M6I8BcHed4Y0uCoazgsZNV2</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>CsdiO8EDyFYIIcbNQmIAgFp2Bvu2</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center blanco zindex10">&nbsp;</div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 3</div>
                  <div class="col-12 fG bold">06 al 12 de abril de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO UNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>3zI5bg7IKEWriYUdzhzrdAX9Cgd2</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>OwXHxfYRtkeLfSwtdkBtgtze9bw2</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>HVSPCsUWYpPulFUfssP5ewXLJY72</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>t6nAIfot9yWe4KWLiN4KqfoaGqp1</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>d7Phx0DThJMOrjSTcBycbH7rjvQ2</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>W5e299Zg65QurFakeJ8ne5BNV4g2</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>nFUCNchHPPUU66qHjX6Fin6B2Gj2</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ArsZ6AmowdYPZ6abuRfRpWWdFY62</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>RHffwsrVCZR6GWbtuRH4ReNLaxh2</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>BfVtwZ4CIxOKQbprGGckxzq7Pez2</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>9l3GE47aFmhJOIIqVqRfx4M89kg1</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>3iHnCuoCpdUPBpLryKbaHzxxqRd2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>i3Yrlk2N6RgefZ6pmxTN5lX9pKy1</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>9nHH3myMWVT2IIiR5o3T5mzJCX22</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>A4kMiyAOfOWcPA2ypUBiSf5aIYr2</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>UbpGPsAyXUUddWOM9pJj38yGIQp1</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>Uzc3ueKgIJYYajwLxR5vofdUF0q2</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>B75PhAxNsaXRHXIVqgiShqAVfw33</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>tbIX9rotjAelm4n4J6T06Jfmn9G2</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>lA9NjxUhh3N08UO60ADAge5FUcl2</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 4</div>
                  <div class="col-12 fG bold">13 al 19 de abril de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO UNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>BRSf38KhVdP6HsHbjgwr2RyIUSd2</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>c9MZ6zu3qzLnC2XBBs3YKTJmI3m1</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>z5nhwyxynFQsWiGAeLskybRwALc2</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>cyd4M6hHDQMRshxs5U4CR5dDwhD2</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>6FTy3H3RJrbCucJYCXJuVn7fqHJ3</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>dk96LJNiqyc382yV84X6MhuHHcl1</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>VixNkRX1KuTdxj3YTViheo9L5Xc2</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>wFmSg962MEcV1DE18hQNh3vsDvp2</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>rPZr9uOtchTKDcAdOHn7qqLrfkn1</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>Fy6Ajb6uwZUFT9o6r47yTDy2zI72</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>RylIUWlUqKWtC9bmJNTIjeJyqsD3</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>BqdeJkX2YCOrhJokSBBuXAAwDwx2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>lOAVzRSub5MHylwjrqdy1HfGwcJ3</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>KhB7ddM4ifaw4POMh2dTvsUYFdX2</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>F5tQIIclZDeUdcA0cPaC4iR4ETg1</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>MKOIGHNl76f1GAubyJuRAYyB49Z2</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ppMsgt8J4jVK1S1DgeJW8eTz5aD2</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>0yenT2wKTldPKQuZskbApzzznhi2</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>vFThHeUwAEVny6mS1vutJMIm1u62</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>o0yytxSNlneSFkMONLVnAWv5Z3t1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 5</div>
                  <div class="col-12 fG bold">20 al 26 de abril de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO UNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>MJg1tpBxWGUGIDggs1czfG2WqRP2</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>LO5IReiVNZZJ5jtbVjiOAVZAP903</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>8zC2BRl8RdVtQe4T1WPYmO2npNe2</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>nrxoAWxzrqUJRVYwa2JreOjDdE32</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>CH7QdDblFsTC0q23yidQfXAN8fP2</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>WBGYcTPM8CeHoyq7D5a8uxSUDYw2</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>6l5YYI8a2Bd47RFXdnZWEkGO8Pu1</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>PL4SiFfzCjUGZcQK1mRCahSngOm1</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>gaSkPTtF7JhBZuIbUQA1KYThOFg1</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>CjcpwkX9YaXdNk4jkZ21fVScsci2</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>G0Hy9af9z5NnZT4ztii1qS8jJLk2</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>jZpO03ZeMTgqtHJay5Ul7gAOFqb2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>mX49y2EOiZZMrwLL2c4fucVGaQD2</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>oeY1ALv2E8QunwJzAzeie1IfMkL2</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>jf5KTy2MysTL9J4qYrRIcwtV8602</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>GZ6IanxmuTXGfJ3g3IzHcjf5z5H3</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>eO40YDKQW7OwRAy6OZU81QSjIcl1</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ifdugXWDyrYjhdsC2hX8dLVUPNi2</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>rxmhzGk2JEaTbuqas9Euk6Z10RA2</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>bS46rxau3sMm4NftpfwrP1FTxRh1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 6</div>
                  <div class="col-12 fG bold">
                    27 de abril al 03 de mayo de 2026
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO UNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>WQ0K0Pg0bxd5ln9HZzjkpqU4ZeZ2</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>W3agcBvFhwYKLsnJjlg1VuqsDpi1</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>FCw7Fn2SPsYs5SVufHdho3CJENP2</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>6v2qjrvfSScVRKGIGgrFNGE8Sgi2</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>JIVXAg0d5PhcDPM2XAcS8gHwdPO2</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>vX9eU8WMuHZ28STJqrBBEd4IzTX2</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>BQj1wHxfLfTnkjEpCSnPbeHfeQ52</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>HfOMCjeWlnfw9Xb9BOll1GS4Nql1</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>XFY6zlV0OvUvuBJzCD5JBixRbXD2</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>fnXysrQFjycPNa3me9Pg9ykS0v72</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>dwXM2JlmggTEMOvXReaAxm7rWqT2</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>UJn9mNGttfRCYZqMgoc02fGv4tJ2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>tmLijhGEz1WV4femcandpeM95U62</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>etqsSfrjfPVSfEvXyU6obPfThWi2</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>CtJRmVPKlJg20DTDSlmcmPgl1AW2</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>LNVjj1HEGYeDrlUwIy66bD8XYMj2</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>gBSIsxAXt6R1KHOULGlY2UfMGD53</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>0GQiGSWWNFV2TS4WPspP6Y4np2F3</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>DYd0PyD4UCdguTzWLIjitmXg1ua2</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>4Xjo3vt6HCVrCLh4YGG8Xa5xEBw1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 7</div>
                  <div class="col-12 fG bold">04 al 10 de mayo de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>Lugar</th>
                          <th>Incentivo</th>
                          <th>Número único de participante</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            Pantalla marca Hisense Smart TV QLED de 55 pulgadas
                            4K/UHD con AI Smooth Motion
                          </td>
                          <td>x2yFO0m3srOLporihVzwnd9aJY63</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            Pantalla marca Hisense Smart TV QLED de 55 pulgadas
                            4K/UHD con AI Smooth Motion
                          </td>
                          <td>mucEGjYc3CM0bIWIEvvjSerU3wY2</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            Pantalla marca Hisense Smart TV QLED de 55 pulgadas
                            4K/UHD con AI Smooth Motion
                          </td>
                          <td>VWY0Anv1gnY417y8ou0D5qiVqTt2</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>3xbjPhUGLyf3hgP5dieXhMCbQXB3</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>aXv0MnDJRkY4keLdFBDCC76TdsA2</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>CcHg0NmM06MStpPuyC0OJd8EClK2</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>UypNLgXYHCMyHeBRdhEYahL1dEE2</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>UGEsDlVqTORuOre5IlgtEUu8Uy63</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>q3fsDVYBUJguV3FgVrpkknz8PHk2</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>aNFvuxlHBAZA5mYEII2PElwCBqc2</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>b2RC3rykHSen2nttSpAqazWfesK2</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>0tZel93nY5Nvrmw4NkrbrOrYVt63</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>LHm9Gzvj4odOATRwA0jeC3uoVlk1</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>GMixgYtvp4PBRHBUu9dVNBu0sbt2</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>wPxV6m1upEhzwou1FjULoL4xQVJ2</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>FWgPMVjjpygbrWafesui6X9vPoE2</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>0snF6T8x36e3dPZ5RnzLXyj7Yzv2</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>ttRk8vk8LhXEax2ZptI7qmyTeu02</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>va8cdux1ZPN2K1660i7tXjdYYDk2</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            Jersey Selección Nacional de México marca Adidas
                          </td>
                          <td>ABXZEDSZRhf9jhp2AwJeLxcOQhk2</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 8</div>
                  <div class="col-12 fG bold">11 al 17 de mayo de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="border-collapse: collapse; width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO ÚNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>yrVkU2V5bfcYnPexhAsrXxWtdqh1</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>0doJlr4buTcdG05RKC408k96Myf2</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>sYD4UWa6dTf6lqfMx5pk6sRVcK02</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>krQWzVuKvMOndUWvQksbqZfR2pV2</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>SnhsMwIO4vTzyub32LdhUoIgZ8p1</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>4cRAqn5uakYNLJJV34CscDYE8q83</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ufIEs8qk12VhI9RfJRN5MsGp7ax2</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>GkkMoboJCkU51dkD1IWigfqUKbF2</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>e8jGs120WhegFP5ladjYN0ElfuF3</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>HyBBYQtTc8d4GArFiT8i4bD4gaG3</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>gIMceo8MCnO3aRHy4ClxAVc7ZLm2</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>OAyFoy4iDfc9wL8oHv31n5AETBI2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>rOF2f8BeJpOvajGjv8CWEq9pXDs2</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>wFouYUGSPWgIOWMgjQhEpQo36913</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>xE6nlbosvtgkulipR1PqC8BE28r2</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>YNKCS4xQCIN2eUTTptw8TSgdeIE2</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>gscUiiiCQmMRCSNeh9XxhNHL7B92</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>n9vNdCtscrhHwEtJEWooV0AXIXJ3</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>LKKW9U1uTrPskrSStkUNKdpIbAp2</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>aqmN6ookRFQ0KrRty8OOOqJjbYu1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 9</div>
                  <div class="col-12 fG bold">18 al 24 de mayo de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellspacing="0"
                      cellpadding="8"
                      style="
                        border-collapse: collapse;
                        width: 100%;
                        text-align: left;
                      "
                    >
                      <thead>
                        <tr style="background-color: #008bd2; color: #ffffff">
                          <th style="text-align: center">LUGAR</th>
                          <th>INCENTIVO</th>
                          <th>NÚMERO UNICO DE PARTICIPANTE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="text-align: center">1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>NamC3gveCoXsQAHE7Z9vOmabJGq2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>yGKQHY7hdfaJ5SkZyUW7XJjFsZx2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>f1Bqz8DoqAaU4ph234qBB3dRKA83</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ipgEYM5xUNerDrZiOrD6mc95kZy2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>kTQJd5vEYsfU6tPcUzQRd2E6Tg73</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>Z8BiPJOK6UgIFGEV7XgzCj6YDTC2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>GoOpHCIaoeNXccx1FSSdkx0Jyb62</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ca49EDT9QZbtyce0Cd1LeNJBFeL2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>1GbCCVLbXgP0h4LiHrgn8V88oOb2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>n40nIKCoweUm08IkHPmv6k8B3e13</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ursvtISduDd36xE7T8QIUxNo1XE3</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>92OqOQ74RHdKv2pObWXOADM6Hb23</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>oZvPWK1a6db10r88CeOxwJCNYsi2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>TmQ7GAa9nehQwBqX6rvKlg1QLrf2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>KM3WPG6Y7sfvRZZ56U6mCLEQniq1</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>ohfuXgaNNXXLaTn3lZT9DVPp6o93</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>buNhSkwXuiZKJzXLQBal9yvbBDF3</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>b6oklP3qUKTMlGHjegdIFKUhrUC3</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>9srPV8nngqY3BWxVlJ8qhT9F4q83</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                          </td>
                          <td>FBOMGcnfqGUkBmRKKvnfX8UPBHd2</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 10</div>
                  <div class="col-12 fG bold">25 al 31 de mayo de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <div class="tabla-responsive">
                      <table
                        class="tableganadores"
                        border="1"
                        cellspacing="0"
                        cellpadding="8"
                        style="
                          border-collapse: collapse;
                          width: 100%;
                          text-align: left;
                        "
                      >
                        <thead>
                          <tr>
                            <th scope="col">LUGAR</th>
                            <th scope="col">INCENTIVO</th>
                            <th scope="col">NÚMERO ÚNICO DE PARTICIPANTE</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>Anw9uRWFHmeSiPguB0AfckKAKvl2</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>57UsyKZgUQMXTTcHL1dUjW1HyzF2</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>GRh6Ly7m24QDsXWE31qnWklf9Dj2</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>PhOb4BVOjROlgTMkdFswJf3Uedj2</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>1IU4Vl0glmUT5XiP3SHQP21Qhfl2</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>jOHEYcG5g9dglCHDHhrRUl2xbMt2</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>tWE1kffd9YhSGl6dl6Q0ye8kq4R2</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>SSLzgmz64PQxEkv1MZPARF6fDk83</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>N3xurxy1NBP1QMJZcYqNXNjWeTa2</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>DlIoLN06YcY8vZRIWzbdZ54cec83</td>
                          </tr>
                          <tr>
                            <td>11</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>GwCtgU1kF6VqZMbq28X3PiW9mtG2</td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>sMnXVdVczoNv9amhbMztbu3gmEz2</td>
                          </tr>
                          <tr>
                            <td>13</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>sF8uoNOWtmcCau2HsgnPu2kUBzC3</td>
                          </tr>
                          <tr>
                            <td>14</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>upvQ6mAsEHcEmN4m8vSmiJ40I6h1</td>
                          </tr>
                          <tr>
                            <td>15</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>5TLybCTpQ7R1vDZbELHM1RpXikV2</td>
                          </tr>
                          <tr>
                            <td>16</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>5tXs8lkiVOW4Je2LamyDqCGGpDP2</td>
                          </tr>
                          <tr>
                            <td>17</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>XYJZNdyc6SXaWfMikhHdaSruPyD2</td>
                          </tr>
                          <tr>
                            <td>18</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>i3knUB7xNbPvJMYxCh52vzpRfiM2</td>
                          </tr>
                          <tr>
                            <td>19</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>gsYDW2PvF9gKe0BSJ3Tdy8KDAZZ2</td>
                          </tr>
                          <tr>
                            <td>20</td>
                            <td>
                              JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS
                            </td>
                            <td>wi5nljuawtSDJtlTOKenIDBmwZs2</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">INCENTIVOS REASIGNADOS</div>
                  <div class="col-12 fG bold">
                    23 de marzo al 31 de mayo de 2026
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <div class="tabla-responsive">
                      <table
                        class="tableganadores"
                        border="1"
                        cellspacing="0"
                        cellpadding="8"
                        style="
                          border-collapse: collapse;
                          width: 100%;
                          text-align: left;
                        "
                      >
                        <thead>
                          <tr>
                            <th>LUGAR</th>
                            <th>INCENTIVO</th>
                            <th>NÚMERO ÚNICO DE PARTICIPANTE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>V14EutiAebOy3K05729boDQdYTK2</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>ySamnSeJPUXwhG9TULo5QD7OG3g1</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>MjoAP2HQLoRrmsl5Z2TQbNv32So1</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>t6nAIfot9yWe4KWLiN4KqfoaGqp1</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>d7Phx0DThJMOrjSTcBycbH7rjvQ2</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>rPZr9uOtchTKDcAdOHn7qqLrfkn1</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>KhB7ddM4ifaw4POMh2dTvsUYFdX2</td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>6v2qjrvfSScVRKGIGgrFNGE8Sgi2</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>vX9eU8WMuHZ28STJqrBBEd4IzTX2</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              PANTALLA MARCA HISENSE SMART TV QLED DE 55
                              PULGADAS 4K/UHD CON AI SMOOTH MOTION
                            </td>
                            <td>BQj1wHxfLfTnkjEpCSnPbeHfeQ52</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row py-5">
          <div class="col-12 text-center azul fXXG">DORES</div>
          <div class="col-12 text-center  azul fG py-2">Consulta la lista de dores semanales aquí:</div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/dores"
              class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Lista de dores semanales
            </router-link>
          </div>
        </div> -->
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";
import moment from "moment";

import samsLogo from "../assets/imgs/flow/productos-participantes-sams.png";
import walmartLogo from "../assets/imgs/flow/productos-participantes-walmart.png";

import colgate1 from "../assets/imgs/datumax/productos/colgate-max-white.png";
import walmartPremios from "../assets/imgs/flow/premio-walmart.png";

import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      products: [
        {
          name: "Producto 1",
          description: "Este es el producto 1",
          image: "../assets/imgs/datumax/productos/colgate-max-white.png",
        },
        {
          name: "Producto 2",
          description: "Este es el producto 2",
          image: colgate1,
        },
        {
          name: "Producto 3",
          description: "Este es el producto 3",
          image: colgate1,
        },
        {
          name: "Producto 4",
          description: "Este es el producto 4",
          image: colgate1,
        },
      ],
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        genero: "",
        terminosedad: "",
        terminos: "",
        terminoscondiciones: "",
        medio_de_contacto: "",
        estado: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      showPasswordLogin: false, // Para login
      showPasswordSignup1: false, // Para signup password
      showPasswordSignup2: false, // Para signup confirm
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
    logoSrc() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return samsLogo;
      if (tienda === "walmart") return walmartLogo;
      return "";
    },
    textoTienda() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return "Sam´s Club";
      if (tienda === "walmart") return "Walmart y Bodega Aurrera";
      return "";
    },
    groupedProducts() {
      const groups = [];
      for (let i = 0; i < this.products.length; i += 2) {
        groups.push(this.products.slice(i, i + 2));
      }
      return groups;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1980-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      // Validar contraseña
      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      // Confirmación de contraseña
      if (this.signupForm.password !== this.signupForm.password2) {
        swal.fire(
          "Oops",
          "La confirmación de contraseña no coincide con el campo de contraseña.",
          "warning"
        );
        return false;
      }

      // Validar teléfono
      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      // Validar edad (18 años o más)
      if (!this.signupForm.fecha_nacimiento) {
        swal.fire("Oops", "Debes ingresar tu fecha de nacimiento.", "warning");
        return false;
      }

      const fechaNacimiento = moment(
        this.signupForm.fecha_nacimiento,
        "YYYY-MM-DD"
      );
      const hoy = moment();
      const edad = hoy.diff(fechaNacimiento, "years");

      if (edad < 18) {
        swal.fire(
          "Oops",
          "Debes tener al menos 18 años para registrarte.",
          "warning"
        );
        return false;
      }

      // Todo validado, registrar
      this.registro();
    },

    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminosedad: false,
        terminos: false,
        terminoscondiciones: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
